module.exports = __webpack_public_path__ + "static/media/pdfIcon.03441394.svg";